<template>
  <div class="dashboard">
    <v-container>
      <InfDB v-if="inf" :settings="settings" />
    </v-container>
    <v-layout row wrap py-2 PAGING>
      <v-flex xs12 sm12 md12>
          <div class="text-xs-center">
            <div><v-chip v-if="!loading" color="success" text-color="white">
              {{filteredLeads ? filteredLeads.length : 0}} results  
              </v-chip></div>
            <v-pagination
              v-model="currentPage"
              :length="pagesNumber"
              :total-visible="7"
              @input="updateVisible"
            ></v-pagination>
          </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap class=" ma-2" LOADINGPLACEHOLDERS>
      <v-flex v-if="loading" xs12 class="text-xs-center" ma-1>
        <v-card v-for="n in pageSize" class="elevation-4 pa-3 mt-1"  :key="n">
          <content-placeholders :rounded="true">
            <content-placeholders-heading :img="false" />
          </content-placeholders>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="ma-2" LEADS>
      <v-flex v-for="(b, i) in visibleLeads" :key="b.key" xs12 ma-1>
        <v-card :class="`elevation-4`">
          <v-toolbar flat dense dark color="secondary">
            <v-toolbar-title class="white--text">{{ b.name }}
              <v-chip>{{ b.order_status }}</v-chip>
              <v-chip v-if="b.paid" label color="success" class="white--text">Paid</v-chip>
              <v-chip v-if="!b.paid && b.payment_failed" label color="error" class="white--text">Failed</v-chip>
                <span style="font-size:11px;">| </span>
                <span
                    style="font-size:11px;"
                    v-clipboard:copy="b.key"
                    v-clipboard:success="clipboardSuccessHandler"
                    v-clipboard:error="clipboardErrorHandler"
                  >{{b.key}}
                </span>
                <span style="font-size:14px;"> | </span>
                <span style="font-size:14px;" v-if="b.order">
                  ${{b.total ? b.total : getBaseTotal(b)}}
                </span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
            <v-divider vertical></v-divider>
              <v-btn flat small
                @click="()=>{
                  if(!showDetails['panel_' + i]) {
                    showDetails['panel_' + i] = true
                  } else {
                    showDetails['panel_' + i] =! showDetails['panel_' + i]
                  }
                }" 
                color="white">expand
              </v-btn>
            </v-toolbar-items>
            <v-avatar
              size="14px"
              :color="getStatus(b)"
            >
            </v-avatar>
          </v-toolbar>
          <v-expansion-panel expand v-if="showDetails['panel_' + i]">
            <v-expansion-panel-content>
              <div slot="header">Order Details 
              </div>
              <v-card>
                <v-card-text class="py-0">
                  <v-layout row wrap>    
                    <v-flex xs12 md12>
                      <v-layout row wrap>
                        <v-flex xs12 v-if="b.order && b.order.length != 0">
                          <v-tooltip top>
                            <v-chip slot="activator" color="primary" class="white--text">
                              Total: ${{b.total ? b.total : getBaseTotal(b)}}
                            </v-chip>
                            <span>Total: {{ b.total_converted_after_tax }}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex ORDERDETAILS
                          v-for="(key, i) in basicFields.filter(f=>{
                            let n = ['order_status', 'confirm', 'processed', 'payment_url', 'cancel_note', 'customer_id', 'note', 'email', 'no_alternative']
                            if (n.indexOf(f) == -1) return f
                          })" 
                          :key="i" 
                          xs12 md4 pa-1>
                          <v-tooltip top>
                            <div slot="activator" class="caption grey lighten-4 grey--text pa-1" style="font-weight:bold;">
                              {{ key.toUpperCase().split('_').join(' ')  }}
                            </div>
                            <span>{{ key.toUpperCase().split('_').join(' ')  }}</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <span slot="activator" class="pa-1" v-if="typeof b[key] == 'string'">
                              {{ key.includes('date') ? getFormat(b[key]) : b[key] }}
                            </span>
                            <span>{{ b[key] }}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row wrap py-3>
                            <v-flex xs12 py-3 style="font-size:20px;font-weight:bold;">
                              ORDER
                            </v-flex>
                            <v-flex xs12>
                              <v-layout row wrap>
                                <v-flex xs3 style="font-size:11px;font-weight:bold;">
                                  Product
                                </v-flex>
                                <v-flex xs3 style="font-size:11px;font-weight:bold;">
                                  SKU
                                </v-flex>
                                <v-flex xs3 style="font-size:11px;font-weight:bold;">
                                  Quantity
                                </v-flex>
                                <v-flex xs3 style="font-size:11px;font-weight:bold;">
                                  Price
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 v-for="(item, t) in b.order" py-1 :key="'items-' + t">
                              <v-layout row wrap>
                                <v-flex xs3>
                                  {{item.product}}
                                </v-flex>
                                <v-flex xs3>
                                  {{item.sku}}
                                </v-flex>
                                <v-flex xs3>
                                  {{item.quantity}} X
                                </v-flex>
                                <v-flex xs3>
                                  ${{item.baseprice}}
                                </v-flex>
                              </v-layout> 
                            </v-flex>
                          </v-layout> 
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex v-if="b.status_timeline" xs12 md6 pa-1 my-1>
                              <v-flex xs12 py-1 style="font-size:20px;font-weight:bold;">
                                Order status Timeline
                              </v-flex>
                              <v-timeline dense class="elevation-2">
                                <v-slide-x-reverse-transition
                                  group
                                  hide-on-leave
                                >
                                  <v-timeline-item
                                    v-for="event in getTimlineArray(b.status_timeline)"
                                    :key="event.key"
                                    small
                                    fill-dot
                                  >
                                    {{ event.key.split('_').join(' ').toUpperCase() }}
                                    <v-chip 
                                      color="primary"
                                      label
                                      small
                                      text-color="white"
                                    >
                                      {{ event.date | formatDate }}
                                    </v-chip>
                                    <v-chip 
                                    color="secondary" 
                                    label
                                    small
                                    text-color="white"
                                    >
                                      {{ event.agent }}
                                    </v-chip>
                                  </v-timeline-item>
                                </v-slide-x-reverse-transition>
                              </v-timeline>
                            </v-flex>
                            <v-flex v-if="b.update_timeline && false" xs12 md6 pa-1 my-1>
                              <v-timeline dense class="elevation-2">
                                <v-slide-x-reverse-transition
                                  group
                                  hide-on-leave
                                >
                                  <v-timeline-item
                                    v-for="event in getUpdateTimlineArray(b.update_timeline)"
                                    :key="event.key + event.date"
                                    small
                                    fill-dot
                                  >
                                    {{ event.key.split('_').join(' ').toUpperCase() }}
                                    <v-chip 
                                      color="primary"
                                      label
                                      small
                                      text-color="white"
                                    >
                                      {{ event.date | formatDate }}
                                    </v-chip>
                                    <v-chip 
                                    color="secondary" 
                                    label
                                    small
                                    text-color="white"
                                    >
                                      {{ event.agent }}
                                    </v-chip>
                                  </v-timeline-item>
                                </v-slide-x-reverse-transition>
                              </v-timeline>
                            </v-flex>
                            <v-flex v-if="b.shipping_status_timeline" xs12 md6 pa-1 my-1>
                              <v-flex xs12 py-1 style="font-size:20px;font-weight:bold;">
                                Shipping status Timeline
                              </v-flex>
                              <v-timeline dense class="elevation-2">
                                <v-slide-x-reverse-transition
                                  group
                                  hide-on-leave
                                >
                                  <v-timeline-item
                                    v-for="event in getShippingTimlineArray(b.shipping_status_timeline)"
                                    :key="event.key"
                                    small
                                    fill-dot
                                  >
                                    {{ event.key.split('_').join(' ').toUpperCase() }}
                                    <v-chip 
                                      color="primary"
                                      label
                                      small
                                      text-color="white"
                                    >
                                      {{ event.date | formatDate }}
                                    </v-chip>
                                    <v-chip 
                                    color="secondary" 
                                    label
                                    small
                                    text-color="white"
                                    >
                                      {{ event.agent }}
                                    </v-chip>
                                  </v-timeline-item>
                                </v-slide-x-reverse-transition>
                              </v-timeline>
                            </v-flex>
                            <v-flex v-if="b.shipping_timeline && false" xs12 md6 pa-1 my-1>
                              <v-flex xs12 py-1 style="font-size:20px;font-weight:bold;">
                                Shipping Timeline
                              </v-flex>
                              <v-timeline dense class="elevation-2">
                                <v-slide-x-reverse-transition
                                  group
                                  hide-on-leave
                                >
                                  <v-timeline-item
                                    v-for="event in getUpdateTimlineArray(b.shipping_timeline)"
                                    :key="event.key"
                                    small
                                    fill-dot
                                  >
                                    {{ event.key.split('_').join(' ').toUpperCase() }}
                                    <v-chip 
                                      color="primary"
                                      label
                                      small
                                      text-color="white"
                                    >
                                      {{ event.date | formatDate }}
                                    </v-chip>
                                    <v-chip 
                                    color="secondary" 
                                    label
                                    small
                                    text-color="white"
                                    >
                                      {{ event.agent }}
                                    </v-chip>
                                  </v-timeline-item>
                                </v-slide-x-reverse-transition>
                              </v-timeline>
                            </v-flex>
                            <v-flex v-if="b.delivery_status_timeline && false" xs12 md6 pa-1 my-1>
                              <v-timeline dense class="elevation-2">
                                <v-slide-x-reverse-transition
                                  group
                                  hide-on-leave
                                >
                                  <v-timeline-item
                                    v-for="event in getDeliveryTimlineArray(b.delivery_status_timeline)"
                                    :key="event.key"
                                    small
                                    fill-dot
                                  >
                                    {{ event.key.split('_').join(' ').toUpperCase() }}
                                    <v-chip 
                                      color="primary"
                                      label
                                      small
                                      text-color="white"
                                    >
                                      {{ event.date | formatDate }}
                                    </v-chip>
                                    <v-chip 
                                    color="secondary" 
                                    label
                                    small
                                    text-color="white"
                                    >
                                      {{ event.agent }}
                                    </v-chip>
                                  </v-timeline-item>
                                </v-slide-x-reverse-transition>
                              </v-timeline>
                            </v-flex>
                            <v-flex v-if="b.delivery_timeline" xs12 md6 pa-1 my-1>
                              <v-flex xs12 py-1 style="font-size:20px;font-weight:bold;">
                                Delivery status Timeline
                              </v-flex>
                              <v-timeline dense class="elevation-2">
                                <v-slide-x-reverse-transition
                                  group
                                  hide-on-leave
                                >
                                  <v-timeline-item
                                    v-for="event in getUpdateTimlineArray(b.delivery_timeline)"
                                    :key="event.key"
                                    small
                                    fill-dot
                                  >
                                    {{ event.key.split('_').join(' ').toUpperCase() }}
                                    <v-chip 
                                      color="primary"
                                      label
                                      small
                                      text-color="white"
                                    >
                                      {{ event.date | formatDate }}
                                    </v-chip>
                                    <v-chip 
                                    color="secondary" 
                                    label
                                    small
                                    text-color="white"
                                    >
                                      {{ event.agent }}
                                    </v-chip>
                                  </v-timeline-item>
                                </v-slide-x-reverse-transition>
                              </v-timeline>
                            </v-flex>
                          </v-layout> 
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>                
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap py-2 PAGING>
      <v-flex xs12 sm12 md12>
          <div class="text-xs-center">
            <v-pagination
              v-model="currentPage"
              :length="pagesNumber"
              :total-visible="5"
              @input="updateVisible"
            ></v-pagination>
          </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {firebase, db, auth, store} from '@/fb';
import dashboardParalex from '../components/dashboardParalex';
import InfDB from '../components/InfDB';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import countriesJSON from '@/countries-ash.json'

export default {
  components:{ dashboardParalex, InfDB },
  data() {
    return {
      loading:true,
      settings:{embed:true, crm: true},
      showDetails:{panel_0:false, panel_1:false, panel_2:false, panel_3:false, panel_4:false, panel_5:false, panel_6:false, panel_7:false, panel_8:false, panel_9:false, panel_10:false, panel_11:false},
      currentPage: 1,
      pageSize: 8,
      pagesNumber:0,
      filteredLeads:[],
      visibleLeads:[],
      taxrates:[],
      basicFields:[],
      orderFields:[],
      countriesFullLoaded:[],
      filters:{order_status:[], shipping_status:[]},
    }
  },
  computed:{
    items() {
      let role =  this.$store.state.role
      return this.$store.state.menu[role]
    },
    role () {
      return this.$store.state.role
    },
    inf(){
      return this.$store.state.inf
    },
    infsite(){
      return this.$store.state.user
    },
  },
  methods: {
    getFormat(date){
      return format(date)
    },
    getUpdateTimlineArray(timeline){
      let timelineArr = []
      for (const key in timeline) {
        if (timeline.hasOwnProperty(key)) {
          const event = timeline[key];
          event.key = event.status
          timelineArr.push(event)
        }
      }
      return timelineArr.sort(function(a,b){
        return new Date(a.date) - new Date(b.date);
      });
    },
    getTimlineArray(timeline){
      let timelineArr = []
      for (const key in timeline) {
        if (timeline.hasOwnProperty(key)) {
          const event = timeline[key];
          event.key = key
          timelineArr.push(event)
        }
      }
      return timelineArr.sort(function(a,b){
        return new Date(a.date) - new Date(b.date);
      });
    },
    getShippingTimlineArray(timeline){
      let timelineArr = []
      for (const key in timeline) {
        if (timeline.hasOwnProperty(key)) {
          const event = timeline[key];
          event.key = key
          timelineArr.push(event)
        }
      }
      return timelineArr.sort(function(a,b){
        return new Date(a.date) - new Date(b.date);
      });
    },
    getDeliveryTimlineArray(timeline){
      let timelineArr = []
      for (const key in timeline) {
        if (timeline.hasOwnProperty(key)) {
          const event = timeline[key];
          event.key = key
          timelineArr.push(event)
        }
      }
      return timelineArr.sort(function(a,b){
        return new Date(a.date) - new Date(b.date);
      });
    },
    goTo(path) {
      this.$router.push(path)
    },
    getStatus(b) {
      if(b.order_status && b.order_status.toLowerCase() == 'new') return `warning`
      if(b.order_status && b.order_status.toLowerCase() == 'confirmed') return `success`
      if(b.order_status && b.order_status.toLowerCase() == 'canceled') return `error`
      return `primary`
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    getBaseTotal(l){
      let total = 0
      let ftaxRate = this.taxrates.filter(x=> x.country == l.country)
      let taxRate = ftaxRate.length ? ftaxRate[0].rate : 0
      for (let i = 0; i < l.order.length; i++) {
        const item = l.order[i];
        total += parseFloat(item.baseprice) * parseFloat(item.quantity)
      }
      return (total + total * parseFloat(taxRate)).toFixed(2)
    }, 
    setFilters(){
      if(this.$route.query && this.$route.query.orders) {
        let a = this.$route.query.orders
        if(a == 'all') {
          this.filters = {order_status:[], shipping_status:[]}
        } else if (a == 'new') {
          this.filters = {order_status:['NEW'], shipping_status:[]}
        } else if (a == 'canceled') {
          this.filters = {order_status:["Cancel - CIM", "Cancel - No Answer", "Cancel - Duplicate", "Cancel - Price", "Cancel - Didn't need the order", "Cancel - Others", "Cancel ID", "Cancel wrong number", "cancel wrong person", "cancel NSA", "Cancel Whatsapp", "Cancel reject previous order", "Cancel - Didn't Request", "Cancel Delivery Fees", "Cancel - Corona (COVID-19)", "Cancel don't have Card ", "Cancel Combine"], shipping_status:[]}
        } else if (a == 'proccessing') {
          this.filters = {order_status:["1st NA", "2nd NA", "3rd NA", "call back", "NEED CHECK", "Call back After 11:00AM", "pending payment"], shipping_status:[]}
        } else if (a == 'confirmed') {
          this.filters = {order_status:['Confirmed'], shipping_status:[]}
        } else if (a == 'pending') {
          this.filters = {order_status:['Dispatch'], shipping_status:[]}
        } else if (a == 'delivered') {
          this.filters = {order_status:[], shipping_status:['Delivered', 'Paid']}
        } else if (a == 'returned') {
          this.filters = {order_status:[], shipping_status:['Returned']}
        }
      }
      this.showLeads()
    },
    filterLeads() {
      this.loading = true
      this.filteredLeads = this.leads
      .filter(x=>{
        if(this.filters.order_status.length){
          if(this.filters.order_status.includes(x.order_status)) {
            return x
          }
        } else {
          return x
        }
      })
      .filter(x=>{
        if(this.filters.shipping_status.length){
          if(this.filters.shipping_status.includes(x.shipping_status)){

            return x
          }
        } else {
          return x
        }
      })
      this.getPagesNumber()
      this.currentPage = 1
      this.updateVisible()
    },
    showLeads(){
      this.leads = []
      this.visibleLeads = []
      this.filteredLeads = []
      this.leads = this.$store.state.inf_orders
      this.visibleLeads = this.leads
      this.filterLeads()
      this.loading = false
    },
    updateVisible() {
      this.sortByDate()
      this.showDetails = {panel_0:false, panel_1:false, panel_2:false, panel_3:false, panel_4:false, panel_5:false, panel_6:false, panel_7:false, panel_8:false, panel_9:false, panel_10:false, panel_11:false}
      this.visibleLeads = this.filteredLeads.slice((this.currentPage -1) * this.pageSize, ((this.currentPage -1) * this.pageSize) + this.pageSize);
      this.loading = false
    },
    sortByDate(){
      this.filteredLeads = this.filteredLeads.sort(function(a,b){
        return new Date(b.import_date) - new Date(a.import_date);
      });
    },
    getPagesNumber(){
      if (this.filteredLeads.length % this.pageSize == 0) {
        this.pagesNumber = parseInt(this.filteredLeads.length / this.pageSize)
      } else {
        this.pagesNumber = parseInt(this.filteredLeads.length / this.pageSize) + 1
      }
    },
    
    async getTaxRates(){
      let a = await db.ref(`taxrates`).once('value').then(x=>x.val())
      this.taxrates = Object.values(a)
    },
    async getSettings(){
      let c = countriesJSON
      this.countriesFullLoaded = Object.values(c)
      await db.ref('settings')
      .once('value')
      .then(snap=>{
        this.loading = true
        let settings = snap.val()
        this.orderFields = settings.orderFields
        return settings
      })
      .then(y=>{
        let r = ['dialog', 'key', 'baseprice', 'product', 'price']
        this.basicFields = Object.keys(y.orderFields)
        .filter(x => r.indexOf(x) == -1 )
        .sort((a,b) => {
          try {
            return y.orderFields[a].order - y.orderFields[b].order
          } catch (error) {
          }
        })
        this.loading = false
      })
    },
    getTotal(l, key){
      if (!l.order || l.order.length == 0) return `0`
      let currRate = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      if(!currRate) return `0`
      let totalBase = 0 
      if(l.order && Array.isArray(l.order))
        l.order.forEach(order=>{
          totalBase += parseFloat(order.baseprice) * parseFloat(order.quantity)
        })
      let total = totalBase * parseFloat(currRate.usd) 
      if (l.voucher) {
        total = total - (parseFloat(l.voucher.amount) * parseFloat(currRate.usd))
      }
      let finalTotal = `${total.toFixed(2)} ${currRate.currencies ? currRate.currencies[0].code  : ''}`
      if(key){
        this.selectedLeads.filter(x=> x.key == key)[0].total = totalBase.toFixed(2)
      }
      l.total_converted = total.toFixed(2)
      l.currency = currRate.currencies ? currRate.currencies[0].code  : ''
      l.payment_cc = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0].alpha2Code
      return finalTotal
    },
    getTotalAfterTax(l, key){
      if (!l.order || l.order.length == 0) return `0`
      let currRate = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      if(!currRate) return `0`
      let totalBase = 0 
      if(l.order && Array.isArray(l.order))
        l.order.forEach(order=>{
          totalBase += parseFloat(order.baseprice) * parseFloat(order.quantity)
        })
      let total = totalBase * parseFloat(currRate.usd) 
      if (l.voucher) {
        total = total - (parseFloat(l.voucher.amount) * parseFloat(currRate.usd))
      }
      let finalTotal = `${total.toFixed(2)} ${currRate.currencies ? currRate.currencies[0].code  : ''}`
      if(key){
        this.selectedLeads.filter(x=> x.key == key)[0].total = totalBase.toFixed(2)
      }
      let ftaxRate = this.taxrates.filter(x=> x.country == l.country)
      let taxRate = ftaxRate.length ? ftaxRate[0].rate : 0
      l.total_converted_after_tax = (total + total * parseFloat(taxRate)).toFixed(2)
      l.tax = (total * parseFloat(taxRate)).toFixed(2)
      l.currency = currRate.currencies ? currRate.currencies[0].code  : ''
      l.payment_cc = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0].alpha2Code
      let finalTotalwithTax = {
        total:`${(total + total * parseFloat(taxRate)).toFixed(2)} ${currRate.currencies ? currRate.currencies[0].code  : ''}`,
        tax:(total * parseFloat(taxRate)).toFixed(2)
      }
      return finalTotalwithTax
    },
  },
  watch:{
    $route (to, from) {
      this.setFilters()
    },
    '$route.query.orders':{
      handler: function(search) {
        this.setFilters()
          console.log(search)
      },
      deep: true,
      immediate: true
    }
  },
  props: {
    userName: {
      required: true,
      default: 'Green Way'
    },
    userImage: {
      required: true,
      default: ''
    }
  },
  async created() {
    this.setFilters()
    this.getTaxRates()
    this.showLeads()
    this.getSettings()
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style>

</style>
